import { createAction, makeActionTrackable } from '@lingoda/core';

export default makeActionTrackable(createAction<{ email: string }>('auth/REQUEST_PASSWORD_RESET'));
